import { status } from "skin/event/status";
import { setAll, toggle } from "../toggling";
import api from "skin/http";
import config from "config_skin";
import { loadTrees } from "../loading";

const TABLE_NAME = "menuExclusion";

export default function msMenuEx(obj, ms, story, data, d, action) {
	const taskId = data.curData.values.fld.taskId;

	if (obj.type === "table" && obj.action === "row") {
		const rows = data.curData.values.table[TABLE_NAME].list;
		const row = rows.find(({ key }) => key === obj.key);
		toggle(TABLE_NAME, data, rows, row);
		return status.ignore;
	}

	if (obj.action === "loadData")
		return api({
			method: "GET",
			url: `${config.url}api/exceptions/menus?taskId=${taskId}`,
		})
			.then(({ data: trees }) => loadTrees(TABLE_NAME, trees, data, ms))
			.then(() => status.action)
			.catch(console.error);

	if (obj.code === "all" || obj.code === "clear")
		setAll(TABLE_NAME, data, obj.code === "all");

	return status.action;
}
